import { UserRoleType } from '~/enums/UserRoleType';
import { Permission } from '~/types/Permission';

import { not } from './utils/not';
import { testHasRole } from './utils/testHasRole';

export const canUseUpload: Permission = not(
  testHasRole(UserRoleType.WorkflowOnly),
);
